/**
 * @generated SignedSource<<1350f597ebb83344cfb7d9cfa6f8a8c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationMembershipsOrderBy = "bio" | "joined_on" | "member_name" | "members_list" | "recently_active" | "%future added value";
export type OrganizationMembershipsProfileFieldStatus = "not_responded" | "responded" | "%future added value";
export type OrganizationRole = "admin" | "member" | "owner" | "%future added value";
export type OrganizationMemberGroupFilterInput = {
  memberGroupId?: string | null;
};
export type OrganizationMembershipsProfileFieldFilter = {
  id: string;
  optionId?: string | null;
  status?: OrganizationMembershipsProfileFieldStatus | null;
};
export type CommunityMembersListPagePaginationQuery$variables = {
  after?: string | null;
  before?: string | null;
  direction?: OrderDirection | null;
  first?: number | null;
  id: string;
  last?: number | null;
  memberGroupFilterInput?: OrganizationMemberGroupFilterInput | null;
  memberGroupIds?: ReadonlyArray<string> | null;
  orderBy?: OrganizationMembershipsOrderBy | null;
  profileFields?: ReadonlyArray<OrganizationMembershipsProfileFieldFilter> | null;
  roles?: ReadonlyArray<OrganizationRole> | null;
  search?: string | null;
};
export type CommunityMembersListPagePaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"CommunityMembersListPage_PaginationFragment">;
  } | null;
};
export type CommunityMembersListPagePaginationQuery = {
  response: CommunityMembersListPagePaginationQuery$data;
  variables: CommunityMembersListPagePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberGroupFilterInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberGroupIds"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "profileFields"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roles"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v12 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v13 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "direction",
    "variableName": "direction"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "memberGroupFilterInput",
    "variableName": "memberGroupFilterInput"
  },
  {
    "kind": "Variable",
    "name": "memberGroupIds",
    "variableName": "memberGroupIds"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "profileFields",
    "variableName": "profileFields"
  },
  {
    "kind": "Variable",
    "name": "roles",
    "variableName": "roles"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "groupKinds",
    "value": [
      "custom"
    ]
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunityMembersListPagePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v12/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v13/*: any*/),
            "kind": "FragmentSpread",
            "name": "CommunityMembersListPage_PaginationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "CommunityMembersListPagePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v12/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "OrganizationMembershipNodeConnection",
                "kind": "LinkedField",
                "name": "organizationMemberships",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrganizationMembershipNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrganizationMembership",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "member",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 2
                                  }
                                ],
                                "concreteType": "OrganizationMembershipNodeConnection",
                                "kind": "LinkedField",
                                "name": "organizationMemberships",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrganizationMembershipNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrganizationMembership",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Organization",
                                            "kind": "LinkedField",
                                            "name": "organization",
                                            "plural": false,
                                            "selections": [
                                              (v16/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "primaryDomain",
                                                "storageKey": null
                                              },
                                              (v15/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "organizationMemberships(first:2)"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bio",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fullName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "avatar",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isTest",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": (v18/*: any*/),
                            "concreteType": "MemberGroupMembershipNodeConnection",
                            "kind": "LinkedField",
                            "name": "groupMemberships",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberGroupMembershipNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MemberGroupMembership",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "productId",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MemberGroup",
                                        "kind": "LinkedField",
                                        "name": "memberGroup",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "parentMemberGroupId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "visibility",
                                            "storageKey": null
                                          },
                                          (v19/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "kind",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "color",
                                            "storageKey": null
                                          },
                                          (v17/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isSystem",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "kind": "LinkedField",
                                            "name": "product",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v19/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v14/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfoObjectType",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v22/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "groupMemberships(groupKinds:[\"custom\"])"
                          },
                          {
                            "alias": null,
                            "args": (v18/*: any*/),
                            "filters": [
                              "groupKinds"
                            ],
                            "handle": "connection",
                            "key": "useMemberGroupTagsList_OrganizationMembershipFragment_groupMemberships",
                            "kind": "LinkedHandle",
                            "name": "groupMemberships"
                          },
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v13/*: any*/),
                "filters": [
                  "memberGroupIds",
                  "memberGroupFilterInput",
                  "profileFields",
                  "roles",
                  "search",
                  "orderBy",
                  "direction"
                ],
                "handle": "connection",
                "key": "CommunityMembersListPage__organizationMemberships",
                "kind": "LinkedHandle",
                "name": "organizationMemberships"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f778e125a521f72ce55e9edc1c643515",
    "id": null,
    "metadata": {},
    "name": "CommunityMembersListPagePaginationQuery",
    "operationKind": "query",
    "text": "query CommunityMembersListPagePaginationQuery(\n  $after: String\n  $before: String\n  $direction: OrderDirection\n  $first: Int\n  $last: Int\n  $memberGroupFilterInput: OrganizationMemberGroupFilterInput\n  $memberGroupIds: [ID!]\n  $orderBy: OrganizationMembershipsOrderBy\n  $profileFields: [OrganizationMembershipsProfileFieldFilter!]\n  $roles: [OrganizationRole!]\n  $search: String\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...CommunityMembersListPage_PaginationFragment_tFKuP\n    id\n  }\n}\n\nfragment CommunityMembersListPage_PaginationFragment_tFKuP on Organization {\n  organizationMemberships(memberGroupIds: $memberGroupIds, memberGroupFilterInput: $memberGroupFilterInput, profileFields: $profileFields, roles: $roles, search: $search, orderBy: $orderBy, direction: $direction, first: $first, after: $after, last: $last, before: $before) {\n    edges {\n      node {\n        id\n        ...OrganizationMemberCardFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      startCursor\n      endCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n  id\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment OrganizationMemberCardFragment on OrganizationMembership {\n  ...RemoveCommunityMemberButtonFragment\n  id\n  role\n  member {\n    ...UserCardFragment\n    id\n  }\n  ...useMemberGroupTagsList_OrganizationMembershipFragment\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment RemoveCommunityMemberButtonFragment on OrganizationMembership {\n  id\n  member {\n    id\n    organizationMemberships(first: 2) {\n      edges {\n        node {\n          id\n          organization {\n            slug\n            primaryDomain\n            id\n          }\n        }\n      }\n    }\n  }\n  organization {\n    id\n    slug\n  }\n}\n\nfragment UserCardFragment on User {\n  id\n  bio\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment useMemberGroupTagsList_OrganizationMembershipFragment on OrganizationMembership {\n  id\n  groupMemberships(groupKinds: [custom]) {\n    edges {\n      node {\n        id\n        productId\n        memberGroup {\n          id\n          parentMemberGroupId\n          visibility\n          ...MemberGroupTagFragment\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d74aedcbede1a8bd84751dc7570cd0f4";

export default node;
